// @flow
import React, { Component } from 'react';

export type ListboxSelectionState = {
  selectedItems: Array<string>,
  lastClicked: ?string,
  lastArrowed: ?string,
};

export type ListboxItem = {
  listId: string,
};

type Props = {
  disabled: ?boolean,
  outerClass: string,
  items: Array<ListboxItem>,
  itemToComponent: Function,
  selectionState: ListboxSelectionState,
};

export default class Listbox extends Component<Props> {
  handleClick: Function;
  handleKeyDown: Function;

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick(
    e: SyntheticMouseEvent<>,
    itemId: string
  ): ?ListboxSelectionState {
    const { items, selectionState } = this.props;
    const newState = computeNewSelectionForMouseClick(
      e,
      itemId,
      items,
      selectionState
    );
    if (newState) {
      return { ...this.state, ...newState };
    }
  }

  handleKeyDown(e: SyntheticKeyboardEvent<>) {
    const { items, selectionState } = this.props;
    if (!selectionState.selectedItems.length) {
      return;
    }
    const newState = computeNewSelectionForKeyDown(e, items, selectionState);
    if (newState) {
      e.stopPropagation();
      e.preventDefault();
    }
    return newState;
  }

  render() {
    const {
      disabled,
      items,
      itemToComponent,
      outerClass,
      selectionState,
    } = this.props;
    return (
      <div className={outerClass}>
        {items.map(i => {
          return itemToComponent(
            i,
            selectionState.selectedItems.includes(i.listId),
            this.handleClick,
            this.handleKeyDown,
            disabled
          );
        })}
      </div>
    );
  }
}

// TODO - refactor to simplify after writing tests.
function computeNewSelectionForMouseClick(
  e: Object, // could be a synthetic event or a test fixture
  itemId: string,
  items: Array<ListboxItem>,
  selectionState: ListboxSelectionState
) {
  const { selectedItems, lastClicked } = selectionState;

  let newState;
  if (e.shiftKey && lastClicked) {
    const iFirst = items.findIndex(i => lastClicked === i.listId);
    if (iFirst >= 0) {
      const iItem = items.findIndex(i => i.listId === itemId);
      const newSelected = items.reduce((acc, i, idx) => {
        if (
          (idx >= iFirst && idx <= iItem) ||
          (idx <= iFirst && idx >= iItem)
        ) {
          acc.push(i.listId);
        }
        return acc;
      }, []);
      newState = {
        selectedItems: newSelected,
        lastClicked: itemId,
        lastArrowed: itemId,
      };
    }
  } else if (e.metaKey || e.ctrlKey) {
    const isIncluded = selectedItems.includes(itemId);
    const newSelectedItems = isIncluded
      ? selectedItems.filter(i => i !== itemId)
      : [...selectedItems, itemId];
    newState = {
      selectedItems: newSelectedItems,
      lastClicked: itemId,
      lastArrowed: itemId,
    };
  } else {
    newState = {
      lastClicked: itemId,
      lastArrowed: itemId,
      selectedItems: [itemId],
    };
  }
  return newState;
}

// TODO - refactor to simplify after writing tests.
function computeNewSelectionForKeyDown(
  e: Object, // could be a synthetic event or a test fixture
  items: Array<ListboxItem>,
  selectionState: ListboxSelectionState
) {
  if (!items || !items.length) {
    return null;
  }

  const { selectedItems, lastClicked, lastArrowed } = selectionState;

  let newState;

  if (e.keyCode === 40) {
    // down arrow
    if (!lastClicked) {
      return {
        selectedItems: [items[0].listId],
        lastClicked: items[0].listId,
        lastArrowed: items[0].listId,
      };
    } else if (e.shiftKey) {
      const iLast = items.findIndex(i => i.listId === lastArrowed);
      if (iLast + 1 < items.length) {
        const newLastArrowed = items[iLast + 1].listId;
        let newSelectedItems: Array<string> = [...selectedItems];
        if (!newSelectedItems.includes(newLastArrowed)) {
          newSelectedItems.push(newLastArrowed);
        } else if (lastArrowed !== lastClicked) {
          newSelectedItems = newSelectedItems.filter(i => i !== lastArrowed);
        }
        newState = {
          selectedItems: newSelectedItems,
          lastArrowed: newLastArrowed,
        };
      }
    } else {
      const iLast = items.findIndex(i => i.listId === lastArrowed);
      if (iLast + 1 < items.length) {
        const lastArrowed = items[iLast + 1].listId;
        newState = {
          selectedItems: [lastArrowed],
          lastArrowed,
          lastClicked: lastArrowed,
        };
      }
    }
  } else if (e.keyCode === 38) {
    // up arrow
    if (!lastClicked) {
      const lastClicked = items[items.length - 1].listId;
      newState = {
        selectedItems: [lastClicked],
        lastClicked,
        lastArrowed: lastClicked,
      };
    } else if (e.shiftKey) {
      const iLast = items.findIndex(i => i.listId === lastArrowed);
      if (iLast - 1 >= 0) {
        const newLastArrowed = items[iLast - 1].listId;
        let newSelectedItems: Array<string> = [...selectedItems];
        if (!newSelectedItems.includes(newLastArrowed)) {
          newSelectedItems.push(newLastArrowed);
        } else if (lastArrowed !== lastClicked) {
          newSelectedItems = newSelectedItems.filter(i => i !== lastArrowed);
        }
        newState = {
          selectedItems: newSelectedItems,
          lastArrowed: newLastArrowed,
        };
      }
    } else {
      const iLast = items.findIndex(i => i.listId === lastArrowed);
      if (iLast - 1 >= 0) {
        const lastArrowed = items[iLast - 1].listId;
        newState = {
          selectedItems: [lastArrowed],
          lastArrowed,
          lastClicked: lastArrowed,
        };
      }
    }
  }
  return newState ? { ...selectionState, ...newState } : null;
}



// WEBPACK FOOTER //
// ./src/view/Forms/Listbox.js